







import { Component, Prop, Vue } from "vue-property-decorator";

import { CookieHelper } from "./helper/cookieHelper";
import { DateHelper } from "./helper/dateHelper";
import { CloudHelper } from "./helper/cloudHelper";
import { GetUniqueStrHelper } from "./helper/getUniqueStrHelper";
import { Const } from "@/const";

import "normalize-css";

import { LogHelper } from "@/helper/logHelper";
import { InitializeHelper } from "@/helper/initializeHelper";
import { DebugHelper } from "@/helper/debugHelper";
import { FileHelper } from "@/helper/fileHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { NativeHelper } from "@/helper/nativeHelper";
import { FontHelper } from "@/helper/fontHelper";
import platform from '@/helper/platform';

import { Document } from '@/model/document2/document'
import { TextLayer } from "@/model/document2/page/surface/design/layer/textLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";
import { DataContainer } from '@/model/dataContainer/dataContainer';
import { Product } from '@/data/productCategory/product/product';
import { Paper } from '@/data/productCategory/product/paper/paper';

import { CloudAccount } from "@/cloudAccount/cloudAccount";
import { MessageCenter } from './model/messageCenter/messageCenter';
import ipcApi from '@/api/ipc-api'

@Component({
  components: {}
})
export default class App extends Vue {

    cloudSignOutTime = Const.LABELYASAN_CLOUD_SIGN_OUT_TIME;

    private isMobile() { return UserAgentHelper.isMobile(); }
    private isGrayMaskVisible = false;
    private grayMaskInvisibleTimerId : number = 0;

    created()
    {
        // 再読み込みされたらトップページに戻る
        if (this.$route.name !== 'Top2' && this.$route.name !== 'newsAll' &&
            this.$route.name !== 'TrimEditor' && this.$route.name != 'BlankView' &&
            !UserAgentHelper.isMobile()) {
            this.$router.push("/");
        }

        // hashモードで起動しているとき、URLに/#/が自動付与される関係で、
        // this.$route.queryでのクエリ取得ができない。URLから直接取得して解析する。
        var url = window.location.href;

        // クエリを取得する
        // this.$route.queryは、hashモードでは正常に動作しない
        var query = InitializeHelper.getQueryFromUrl(window.location.href);
        DebugHelper.trace("Query: ");
        DebugHelper.trace(query);

        var productCode = "";
        var paperRotate = 0;
        var templateId = 0;
        var isKeepRatio = false;
        var designRotate = 0;
        var startPath = "";

        // クエリを解析する
        for(var key in query)
        {
            var value = query[key];
            if(key == "product_code")
            {
                // 日本語が入っている場合はデコード
                if(value.indexOf("%") >= 0) { value = decodeURI(value); }
                productCode = value;
            }
            else if(key == "rotate" && parseInt(value) != NaN)
            {
                var rotate = parseInt(value);
                if(rotate == 0 || rotate == 90 || rotate == 180 || rotate == 270)
                {
                    paperRotate = rotate;
                }
            }
            else if(key == "template_id" && parseInt(value) != NaN)
            {
                templateId = parseInt(value);
            }
            else if(key == "keep_ratio")
            {
                isKeepRatio = value == "1";
            }
            else if(key == "design_rotate")
            {
                var rotate = parseInt(value);
                if(rotate == 0 || rotate == 90 || rotate == 180 || rotate == 270)
                {
                    designRotate = rotate;
                }
            }
            else if(key == "open_layout")
            {
                if(value == "1") { startPath = "/LayoutEditor"; }
            }
            else if(key == "open")
            {
                startPath = "/" + value;
            }
            // debug
            else if(key == "use_simple_text")
            {
                this.$store.getters.applicationState.useSimpleText = parseInt(value);
            }
        }

        this.$store.getters.applicationState.startProductCode = productCode;
        this.$store.getters.applicationState.startPaperRotate = paperRotate;
        this.$store.getters.applicationState.startTemplateId = templateId;
        this.$store.getters.applicationState.startKeepRatio = isKeepRatio;
        this.$store.getters.applicationState.startDesignRotate = designRotate;

        this.$store.getters.applicationState.startPath = startPath;
    }

    // Webフォントを読み込む
    private loadWebFonts() {
        FontHelper.loadWebFonts(
            () => {
                this.$store.state.fontLoaded = true;
            }, () => {
                this.$store.state.fontLoaded = true;
            }
        )
    }

    mounted(){
        this.loadWebFonts();

        // CookieHelper.removeItem("colorSkin")

        //トップページでAppがmountされたとき、セッションIDを更新する
        // if(this.$router.currentRoute.name == "Top2"){
            this.setSessionId();
        // }
        //Appがmountされたとき、(urlはトップページである必要はない)もしinstallIdがクッキーになかったらこれを更新する
        if(!CookieHelper.hasItem("installId")){
            this.setInstallId();
        }

        // 行動履歴は必ず取るようになった
        if(CookieHelper.getItem("sendHistory") != true){
            CookieHelper.setItem("sendHistory" , true);
        }

        if(UserAgentHelper.getBrowser() == "ie"){
            CookieHelper.setItem("ieAlertShown", false);
        }

        // ステージングならラベル屋さんクラウドのログイン判定
        // if(window.location.href.indexOf("labelten-test.labelyasan.com") >= 0){
            this.checkLabelyasanCloudSignIn();
        // }

        // ラベル屋さんクラウドの自動ログアウト
        window.addEventListener("keypress", () => {
            if(this.cloudAccount.isSignIn){
                CloudHelper.cloudSignOutTimer(this.cloudAccount);
            }
        })
        window.addEventListener("click", () => {
            if(this.cloudAccount.isSignIn){
                CloudHelper.cloudSignOutTimer(this.cloudAccount);
            }
        })
    }

    //セッションIDをクッキーに格納
    setSessionId(){
        CookieHelper.setItem("sessionId" , GetUniqueStrHelper.getUniqueStr());
        DebugHelper.trace("setionId:");
        DebugHelper.trace(CookieHelper.getItem("sessionId"));
    }

    //installIdをクッキーに格納
    setInstallId(){

        //同期通信でする(helper使わない)
        const XHR = new XMLHttpRequest();
        const query = Const.API_URL_BASE + `get_install_id.php`;
        var param = `platform=${platform.id}`;

        XHR.open('POST', query, false);
        XHR.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        XHR.onreadystatechange = (() => {
            if (XHR.readyState == XMLHttpRequest.DONE && XHR.status === 200) {
                CookieHelper.setItem("installId" , JSON.parse(XHR.response).data.installId);
            }
        });
        XHR.send(param);
    }

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get backgroundColorStyle(){
        return {
            "background-color" : this.userConfigColors.backgroundColor
        }
    }

    // Mobile, DL版からのメニューのコール
    public execCommand(command : string, parameter : any)
    {
        DebugHelper.trace("Exec Command : " + command);
        DebugHelper.trace("Parameter : ");
        DebugHelper.trace(parameter);

        // メッセージセンター取得
        const messageCenter = this.$store.getters.messageCenter;
        // コマンドをメッセージとして送る
        messageCenter.send("exec_command", { "command" : command, "parameter" : parameter });
    }

    // 付けたり外したりするのでexecCommandとは分ける
    public setThumbnail(thumbnail: string) {
        const mc = this.$store.getters.messageCenter;
        mc.send("set-thumbnail", { thumbnail });
    }

    // Mobile, DL版からの現在の画面取得
    // "/LayoutEditor", "/DesignEditor" などが返る
    public getCurrentRoutePath()
    {
        return this.$router.currentRoute.path;
    }

    // Mobile, DL版から差し込みモードかどうか取得する
    public isInsertion()
    {
        return this.$store.getters.applicationState.flowMode >= 1;
    }

    // Mobile, DL版からの値のゲット
    public getValue(kind: string, parameter?: any)
    {
        var value = "";
        try
        {
            if(kind == "document")
            {
                // ドキュメント
                var document = this.$store.getters.document;
                value = FileHelper.getDocumentJson(document);
            }
            else if(kind == "documentAsZip")
            {
                // ドキュメントを圧縮して取得
                let zipBin = FileHelper.convertDocumentToSaveBuffer(this.$store.getters.document);
                if(zipBin != null)
                {
                    // Uint8Array -> binaryString
                    let bs = FileHelper.convertBufferToBinaryString(zipBin);
                    // binaryString -> base64(Data Url)
                    value = "data:application/zip;base64," + window.btoa(bs);
                }
            }
            else if(kind == "current_layer")
            {
                // カレントレイヤー
                var document = this.$store.getters.document;
                var page = document.pageList[document.currentPageIndex];
                var surface = page.getSurface(document.isReverseSurface);
                var design = surface.getDesign(page.currentDesignPosition);
                if(design != null)
                {
                    var currentLayer = design.currentLayer;
                    if(currentLayer != null)
                    {
                        value = JSON.stringify(currentLayer);
                    }
                }
            }
            else if(kind == "current_page_index")
            {
                // 現在の選択ページ
                var document = this.$store.getters.document;
                value = "" + document.currentPageIndex;
            }
            else if(kind == "page_count")
            {
                // ページ数
                var document = this.$store.getters.document;
                value = "" + document.pageCount;
            }
            else if(kind == "print_pdf")
            {
                // 印刷用PDF
                value = this.$store.getters.userConfig.exportedPDF;
            }
            else if(kind == "export_image")
            {
                // 出力イメージ
                value = this.$store.getters.userConfig.exportedImage;
            }
            else if(kind == "has_reverse_surface")
            {
                // 裏面があるかどうか
                var document = this.$store.getters.document;;
                value = document.hasReverseSurface ? "true" : "false";
            }
            else if(kind == "is_reverse_surface")
            {
                // 裏面かどうか
                var document = this.$store.getters.document;
                value = document.isReverseSurface ? "true" : "false";
            }
            else if(kind == "current_layer_property")
            {
                // カレントレイヤーのプロパティ
                var document = this.$store.getters.document;
                var page = document.pageList[document.currentPageIndex];
                var surface = page.getSurface(document.isReverseSurface);
                var design = surface.getDesign(page.currentDesignPosition);
                if(design != null)
                {
                    var currentLayer = design.currentLayer;
                    if(currentLayer != null)
                    {
                        var layerVal = currentLayer[parameter.propertyName];
                        if(layerVal != null)
                        {
                            if(typeof(layerVal) == "object")
                            {
                                if(layerVal instanceof ColorConstruct)
                                {
                                    value = layerVal.hex;
                                    if(value.substr(0, 1) == "#") { value = value.substr(1, 6);}
                                }
                            }
                            else if(typeof(layerVal) == "number")
                            {
                                value = "" + layerVal;
                            }
                            else if(typeof(layerVal) == "boolean")
                            {
                                value = layerVal ? "true" : "false";
                            }
                            else if(typeof(layerVal) == "string")
                            {
                                value = layerVal;
                            }
                        }
                    }
                }
            }
            else if(kind == "insertion_data_as_csv")
            {
                // 差し込みデータのCSV
                var document = this.$store.getters.document;
                value = document.insertionData.getCsv();
            }
            else if(kind == "trim_image")
            {
                // イメージのトリム情報
                var trimImage = {
                    x : this.$store.getters.applicationState.trimSettingX,
                    y : this.$store.getters.applicationState.trimSettingY,
                    width : this.$store.getters.applicationState.trimSettingWidth,
                    height : this.$store.getters.applicationState.trimSettingHeight
                }
                value = JSON.stringify(trimImage);
            }
            else if(kind == "converted_image")
            {
                // コンバートされた画像
                let dataContainter = this.$store.getters.dataContainer as DataContainer;
                var convertedImage = dataContainter.getConvertedImage(parameter.id);
                if(parameter.isDelete === "true")
                {
                    // 画像を消去する
                    this.$store.getters.dataContainter.getConvertedImage.deleteConvertedImage(parameter.id);
                }

                value = convertedImage != null ? convertedImage : "";
            }
            else if(kind == "post_count")
            {
                value = this.$store.getters.snsInfo.snsContentsLength;
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }

        return value;
    }

    // ドキュメントの保存データを得る
    public getDocumentSaveData()
    {
        // ドキュメントを圧縮して得る
        var document = this.$store.getters.document;
        return FileHelper.convertDocumentToSaveBuffer(document);
    }

    // ドキュメントプロパティのゲット
    public getDocumentProperty(propertyName)
    {
        return this.$store.getters.document[propertyName];
    }

    // ドキュメントプロパティのセット
    public setDocumentProperty(propertyName : string, value : any)
    {
        if(this.$store.getters.document[propertyName] != null)
        {
            this.$store.getters.document[propertyName] = value;
        }
    }

    // ドキュメントの変更状態のリセット
    public resetDocumentModified()
    {
        // ハッシュをアップデートする
        this.$store.getters.document.updateHash();
    }

    // ドキュメントが変更されているか取得する
    public isDocumentModified() : boolean
    {
        // Topでは変更なしとして扱う
        if(this.$router.currentRoute.path == "/") { return false; }
        return this.$store.getters.document.isModified();
    }

    // タイトルの変更を行う
    public changeTitle(title : string)
    {
        document.title = title;
    }

    // 特定の画面への遷移
    public pushPage(page : string)
    {
        var newPage = page.length >= 1 && page.substr(0, 1) == "/" ? page : "/" + page;
        this.$router.push(newPage);
    }

    // 用紙、テンプレートの適用
    public setupDocument(productJson : string, paperJson : string, rotate : number = 0, templateId : number = 0, isKeepRatio : boolean = false, designRotate : number = 0)
    {
        // Jsonのパース
        var product : Product = JSON.parse(productJson);
        var paper : Paper = JSON.parse(paperJson);
        // 新規ドキュメント
        var newDoc = Document.create(product, paper, rotate);
        this.$store.dispatch("setDocument", newDoc);

        // 完了処理
        var comp = (success : boolean) =>
        {
            NativeHelper.sendNativeEvent("setup_document_completed", { success : success ? "true" : "false" });
            // ビューに通知する
            this.execCommand("setup_document_completed", {});
        };

        InitializeHelper.applyTemplateToDocument(newDoc, templateId, isKeepRatio, designRotate, () =>
        {
            // 完了
            DebugHelper.trace("setupDocument_completed");
            comp(true);
        },
        () =>
        {
            // 失敗
            DebugHelper.trace("setupDocument_error");
            comp(false);
        });
    }

    // 新規デザイン作成
    public setupNewDesign(pageIndex : number, isReverse : boolean, designIndex : number, templateId : number = 0, isKeepRatio : boolean = false, designRotate : number = 0)
    {
        // 完了処理
        var comp = (isError : boolean) =>
        {
            NativeHelper.sendNativeEvent("setup_new_design_completed", { error : isError ? "true" : "false" });
        };

        var doc = this.$store.getters.document;
        InitializeHelper.applyTemplateToDocument(doc, templateId, isKeepRatio, designRotate, () =>
        {
            // 完了
            DebugHelper.trace("setupNewDesign_completed");
            comp(true);
        },
        () =>
        {
            // 失敗
            DebugHelper.trace("setupNewDesign_error");
            comp(false);
        });
    }

    // モーダル表示状態の取得
    public getModalMode()
    {
        return this.$store.getters.applicationState.modalMode;
    }

    // グレーマスクを表示して、操作を受け付けなくするか設定
    // forceInvisibleTimer : 強制でオフにするタイマー。0より大きい値を指定すると、その時間が経過すると自動でfalseにする
    public setVisibleGrayMaskWindow(visible : boolean, forceInvisibleTimer = 0)
    {
        this.isGrayMaskVisible = visible;
        if(this.grayMaskInvisibleTimerId > 0) {
            clearTimeout(this.grayMaskInvisibleTimerId);
        }
        if(visible && forceInvisibleTimer > 0) {
            this.grayMaskInvisibleTimerId = setTimeout(() => this.isGrayMaskVisible = false, forceInvisibleTimer);
        }
    }

    // クラウドへのドキュメント保存
    public SaveDocumentToCloud()
    {
        this.$store.dispatch("setCloudOperation", this.$router.currentRoute.path);
        this.$store.dispatch("setCloudMode", "save");
        this.$router.push(this.cloudAccount.isSignIn ? "/cloud" : "/signIn");
    }

    private checkLabelyasanCloudSignIn()
    {
        if(!CookieHelper.hasItem("accessLimit") || !CookieHelper.hasItem("refreshLimit")){ return; }
        if(!CookieHelper.hasItem("authorizationToken") && !CookieHelper.hasItem("accessToken") && !CookieHelper.hasItem("refreshToken")){ return; }

        var now = new Date();
        var refreshLimit = new Date(CookieHelper.getItem("refreshLimit"));

        // リフレッシュトークンの期限が過ぎてなければ更新してログインしている判定にする
        if(refreshLimit.getTime() - now.getTime() >= 0){
            CloudHelper.checkRefreshToken((res) => {
                if(res){ return; }
                CloudHelper.updateRefreshTokenTimer(this.cloudAccount);
                this.cloudAccount.isSignIn = true;
                CloudHelper.cloudSignOutTimer(this.cloudAccount);
            })
        }
    }

    public get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    public openFile(path: string, data: any): void
    {
        // ダブルクリックにより読み込んだ時ここにくる
        // ロード中表示をさせるためにイベントを送信する
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.send("opening_project_file", null);
        // ファイルのロードを予約する
        this.$store.dispatch('promiseToOpenDocument', { path, data });
    }

    // インプットモードの取得
    public getInputMode()
    {
        return this.$store.getters.applicationState.inputMode;
    }

    // テキスト編集中か取得
    public isInTextEdit()
    {
        var result = false;
        var doc = this.$store.getters.document;
        if(0 <= doc.currentPageIndex && doc.currentPageIndex < doc.pageList.length)
        {
            var page = doc.pageList[doc.currentPageIndex];
            var surface = page.getSurface(doc.isReverseSurface);
            if(surface != null)
            {
                var design = surface.getDesign(page.currentDesignPosition);
                if(design != null)
                {
                    var currentLayer = design.currentLayer;
                    result = currentLayer != null && currentLayer instanceof TextLayer && currentLayer.inEdit;
                }
            }
        }
        return result;
    }

    /**
     * フォントのキャッシュを再生成する
     */
    public reloadFontFamily(): Promise<void> {
        const manager = this.$store.getters.fontManager;
        if (!manager.ready) {
            return Promise.reject('Font manager is not ready.');
        }
        return manager.loadFontFamily();
    }
}
